import React from 'react';
import MDEditor from '@uiw/react-md-editor';
import '@uiw/react-md-editor/markdown-editor.css';

/**
 * Markdown Editor with built-in preview
 * Uses MDEditor's own preview feature
 */
function MarkdownEditor({ value, onChange, label, height = 400 }) {
  return (
    <div className="space-y-1.5">
      {label && (
        <label className="text-xs text-gray-500 uppercase font-semibold">
          {label}
        </label>
      )}
      <div className="border border-zinc-800 rounded-md overflow-hidden bg-zinc-950">
        <div data-color-mode="dark">
          <MDEditor
            value={value || ''}
            onChange={(val) => onChange?.(val || '')}
            height={height}
            preview="live"
            className="!bg-zinc-950 !border-none"
          />
        </div>
      </div>
    </div>
  );
}

export default MarkdownEditor;

